var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28013 14.2913C7.22046 14.2913 8.06863 13.7709 8.64963 13.0313C9.55524 11.8758 10.6921 10.9221 11.9875 10.2313C12.831 9.78326 13.5625 9.11593 13.916 8.23043C14.1642 7.61005 14.2917 6.94797 14.2916 6.27976V5.54126C14.2916 5.3092 14.3838 5.08664 14.5479 4.92254C14.712 4.75845 14.9346 4.66626 15.1666 4.66626C15.8628 4.66626 16.5305 4.94282 17.0228 5.4351C17.5151 5.92739 17.7916 6.59507 17.7916 7.29126C17.7916 8.63526 17.4883 9.90809 16.9481 11.0456C16.6378 11.6966 17.073 12.5413 17.794 12.5413M17.794 12.5413H21.441C22.638 12.5413 23.7101 13.3509 23.8373 14.5421C23.8898 15.0344 23.9166 15.5338 23.9166 16.0413C23.9215 19.2337 22.8305 22.331 20.8261 24.8158C20.3735 25.3781 19.6746 25.6663 18.9536 25.6663H14.2683C13.7048 25.6663 13.1436 25.5753 12.6081 25.3979L8.97513 24.1846C8.43975 24.0065 7.87917 23.9159 7.31496 23.9163H5.42963M17.794 12.5413H15.1666M5.42963 23.9163C5.52646 24.1554 5.63146 24.3888 5.74463 24.6186C5.97446 25.0853 5.65363 25.6663 5.13446 25.6663H4.07513C3.03796 25.6663 2.07663 25.0619 1.77446 24.0703C1.37038 22.744 1.16554 21.3652 1.16663 19.9788C1.16663 18.1669 1.5108 16.4368 2.13613 14.8478C2.49313 13.9448 3.40313 13.4163 4.3738 13.4163H5.6023C6.15296 13.4163 6.47146 14.0649 6.18563 14.5363C5.18938 16.1762 4.66384 18.0588 4.66663 19.9776C4.66663 21.3706 4.9373 22.6994 5.42963 23.9151V23.9163Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b164ecf7c50f95db6570a3c826adab02.svg";
export { ForwardRef as ReactComponent };